import React from "react";
import { Navigate } from "react-router-dom";
import { useUserAuth } from "../Context/UseAuthContext";

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useUserAuth();

  console.log("Check user in Private: ", currentUser);
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  return children;
};

export default ProtectedRoute;
